import { render, staticRenderFns } from "./GalleryAdd.vue?vue&type=template&id=69b8a89d&scoped=true&"
import script from "./GalleryAdd.vue?vue&type=script&lang=js&"
export * from "./GalleryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b8a89d",
  null
  
)

export default component.exports